<template>
  <div class="pb-3" >
    <va-card :title="$t(`rescues.cards.${titleCard}`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider name="Nome">
                <va-input
                  v-model="rescues.fullName"
                  :label="$t('rescues.headings.name')"
                  disabled
                />
              </ValidationProvider>
              <ValidationProvider name="Produto">
                <va-input
                  v-model="rescues.product"
                  :label="$t('rescues.headings.product')"
                  disabled
                />
              </ValidationProvider>
              <ValidationProvider name="Código">
                <va-input
                  v-model="rescues.trackingCode"
                  :label="$t('rescues.headings.trackingCode')"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="Status" v-slot="{ errors }">
                <va-select
                  v-model="status"
                  text-by='name'
                  key-by='id'
                  :options="statusOptions"
                  clearable="false"
                  noOptionsText="Sem Items"
                  :label="$t('rescues.headings.status')"
                  :placeholder="$t('rescues.headings.status')"
                  :success="errors.length == 0 && status != ''"
                  :error="errors.length > 0"
                ></va-select>
                <ErrorMessages
                  :errors="errors"
                />
              </ValidationProvider>
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="buttonSubmitDisabled"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
                <va-button
                  type="button"
                  class="my-0"
                  color="danger"
                  @click="cancel">
                  {{ $t("forms.cancel") }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import ErrorMessages from '../utils/ErrorMessages.vue'
export default {
  name: 'RescuesUpdate',
  components: { ErrorMessages },
  props: {
    page: {
      type: Number,
      required: true,
    },
    titleCard: {
      type: String,
      required: true,
    },
    updateData: {
      required: true,
    },
  },
  data () {
    return {
      rescues: {
        id: '',
        fullName: '',
        trackingCode: '',
        order_status_id: '',
        product: '',
      },
      statusOptions: [],
      status: '',
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
    }
  },
  apollo: {
    order_status: {
      query: gql`
        query MyQuery {
          order_status {
            id
            name
          }
        }
      `,
      result ({ data, loading }) {
        if (!loading) {
          if (data.order_status.length > 0) {
            this.statusOptions = data.order_status
          }
        }
      },
    },
  },
  mounted () {
    this.rescues.id = ''
    this.rescues.fullName = ''
    this.rescues.trackingCode = ''
    this.rescues.orderStatusId = ''
    this.rescues.product = ''
    if (this.updateData !== null) {
      this.rescues_get(this.updateData)
    }
  },
  watch: {
    updateData (value) {
      if (this.updateData !== null) {
        this.rescues_get(this.updateData)
      } else {
        this.rescues.id = ''
        this.rescues.fullName = ''
        this.rescues.trackingCode = ''
        this.rescues.orderStatusId = ''
        this.rescues.product = ''
      }
    },
    status (value) {
      this.rescues.orderStatusId = value.id
    },
  },
  methods: {
    submit () {
      if (this.updateData != null) {
        this.onUpdate()
      }
    },
    cancel () {
      this.$emit('showUpdate', false)
    },
    rescues_get (data) {
      Object.keys(data).forEach((value, key) => {
        if (value === 'client') {
          const client = data[value]
          this.rescues.fullName = client.fullName
        } else if (value === 'order_status') {
          const status = data[value]
          this.rescues.orderStatusId = status.id
          this.status = status
        } else if (value === 'product') {
          const product = data[value]
          this.rescues.product = product.name
        } else if (value === 'tracking_code') {
          this.rescues.trackingCode = data[value]
        } else if (value === 'id') {
          this.rescues.id = data[value]
        }
      })
    },
    onUpdate () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      const {
        trackingCode,
        orderStatusId,
        id,
      } = this.rescues
      const data = {
        trackingCode,
        orderStatusId,
        id,
      }
      const self = this
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($id: Int!, $trackingCode: String, $orderStatusId: Int!) {
                update_order_by_pk(pk_columns: {id: $id}, _set: {order_status_id: $orderStatusId, tracking_code: $trackingCode}) {
                  id
                }
              }
            `,
          variables: {
            trackingCode: data.trackingCode,
            orderStatusId: data.orderStatusId,
            id: data.id,
          },
        })
        .then(response => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          this.rescues.id = ''
          this.rescues.fullName = ''
          this.rescues.trackingCode = ''
          this.rescues.orderStatusId = ''
          this.rescues.product = ''
          self.$emit('showUpdate', false)
          self.$emit('showMore', self.page)
          self.showToast(
            self.$t('toasts.successUpdate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(e => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          this.rescues.id = ''
          this.rescues.fullName = ''
          this.rescues.trackingCode = ''
          this.rescues.orderStatusId = ''
          this.rescues.product = ''
          self.$emit('showUpdate', false)
          self.showToast(
            self.$t('toasts.errorUpdate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style lang="scss">
</style>
